/**
 * Datos para el Hero Slider
 */

export const HERO_SLIDES = [
    {
        id: 1,
        title: 'Bienvenidos a Bertolt Brecht',
        subtitle: 'La mejor experiencia de aprendizaje',
        description: 'Comunidad educativa de excelencia que potencia integralmente a futuros ciudadanos',
        image: '/assets/images/sliders/IMG_0688.webp',
        buttons: [
            {
                text: '🎓 Admisión 2026',
                link: '/admision-2026',
                variant: 'secondary'
            },
            {
                text: 'Conoce Más',
                link: '/nosotros',
                variant: 'primary'
            }
        ]
    },
    {
        id: 2,
        title: 'Más de 20 años de Excelencia Educativa',
        subtitle: 'Metodología enfocada en el aprendizaje',
        description: 'Formamos líderes comprometidos con la transformación de nuevas generaciones',
        image: '/assets/images/sliders/IMG_0686.webp',
        buttons: [
            {
                text: 'Nuestra Propuesta',
                link: '/propuesta-educativa',
                variant: 'secondary'
            }
        ]
    },
    {
        id: 3,
        title: 'Talleres y Actividades Extracurriculares',
        subtitle: 'Desarrollo integral del estudiante',
        description: 'Básquetbol y cuenta cuentos para potenciar el talento deportivo y la expresión de nuestros estudiantes',
        image: '/assets/images/sliders/img.jpeg',
        buttons: [
            {
                text: 'Ver Talleres',
                link: '/talleres',
                variant: 'secondary'
            }
        ]
    }
];
